import { useParams } from "react-router-dom";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { Tooltip } from "flowbite-react";
import { useAppSelector } from "../../../app/hooks";
import { selectDashboards } from "../../../features/dashboards/dashboardSlice";
import { mapObjectToArray } from "../../../utils/GroupNotificationUtils";
import useGetLanguage from "../../../utils/useGetLanguage";
import { LanguageText } from "../../../dictionary/GroupNotificationText";
interface NotificationDashboardProps {
  dashboard: string;
  onDashboardChange: (dashboardID: string) => void;
}

const NotificationDashboard = ({
  dashboard,
  onDashboardChange,
}: NotificationDashboardProps): JSX.Element => {
  const Language: LanguageText = useGetLanguage({
    fileName: "GroupNotificationText",
  });
  const { groupid } = useParams();
  const { dashboards } = useAppSelector(selectDashboards);
  const groupDashboards = mapObjectToArray(
    Object.fromEntries(
      Object.entries(dashboards).filter(([key, value]) => value.group_id === groupid)
    )
  );

  return (
    <div className="relative mb-6 bg-gray-100 p-5 sm:p-8 rounded-lg mt-10 shadow-sm border border-gray-200">
      <Tooltip
        content={"Associate a Dashboard with notification"}
        placement="top-end"
        style="light"
        trigger="hover"
      >
        <BsFillInfoCircleFill
          size={18}
          color="grey"
          className="absolute top-3 left-3 sm:top-4 sm:left-4 cursor-pointer hover:text-blue-500 transition-colors"
        />
      </Tooltip>
      <h1 className="text-sm sm:text-base font-semibold text-left text-gray-800 leading-tight mb-4 pl-7 sm:pl-8">
        {Language?.dashboard}
      </h1>
      <div className="flex flex-col sm:flex-row sm:items-center w-full">
        <select
          className="border border-gray-300 rounded-md p-2 mb-3 sm:mb-0 sm:mr-4 w-full sm:w-1/2 text-sm focus:ring-2 focus:ring-blue-300 focus:outline-none transition duration-200"
          name="selectInput"
          value={dashboard}
          onChange={(event) => onDashboardChange(event.target.value)}
        >
          <option value="">{Language?.selectDashboard}</option>
          {groupDashboards && groupDashboards.length ? (
            groupDashboards.map((dashboard: any) => (
              <option key={dashboard.id} value={dashboard.id}>
                {`${dashboard.name}  |  ${dashboard.description}`}
              </option>
            ))
          ) : (
            <option value="">{Language?.noDashboardFound}</option>
          )}
        </select>
        {dashboard && (
          <button
            className="w-full sm:w-auto bg-red-500 hover:bg-red-600 text-white font-medium text-sm py-2 px-4 rounded-md shadow-md transition-transform duration-200 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-red-400"
            onClick={() => onDashboardChange("")}
          >
            {Language?.remove}
          </button>
        )}
      </div>
    </div>
  );
};

export default NotificationDashboard;
